var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.visible
    ? _c(
        "Modal2",
        {
          attrs: {
            design: "v3",
            "class-name": "bulk-department-modal",
            "show-footer": false,
            "show-title": false,
          },
          on: { cancel: _vm.onCancel },
        },
        [
          _c("div", { staticClass: "bulk-department-modal-content" }, [
            _c("div", { staticClass: "modal-section" }, [
              _c("div", { staticClass: "selection-wrapper" }, [
                _c("div", { staticClass: "section-title" }, [
                  _c("i", { staticClass: "material-icons" }, [
                    _vm._v("business"),
                  ]),
                  _vm._v(" "),
                  _c("span", [_vm._v("Departman Seçimi")]),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-field" },
                  [
                    _c("label", { staticClass: "field-label" }, [
                      _vm._v("Departmanlar"),
                    ]),
                    _vm._v(" "),
                    _c(
                      "a-select",
                      {
                        staticClass: "department-select",
                        attrs: {
                          mode: "multiple",
                          size: "large",
                          placeholder: "Departman seçin...",
                          "filter-option": _vm.filterOption,
                          "show-search": "",
                        },
                        model: {
                          value: _vm.selectedDepartments,
                          callback: function ($$v) {
                            _vm.selectedDepartments = $$v
                          },
                          expression: "selectedDepartments",
                        },
                      },
                      _vm._l(_vm.availableDepartments, function (department) {
                        return _c(
                          "a-select-option",
                          {
                            key: department._id,
                            attrs: { value: department._id },
                          },
                          [
                            _vm._v(
                              "\n                            " +
                                _vm._s(_vm.getDepartmentName(department)) +
                                "\n                        "
                            ),
                          ]
                        )
                      }),
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "field-hint" }, [
                      _c("i", { staticClass: "material-icons" }, [
                        _vm._v("lightbulb_outline"),
                      ]),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v("Birden fazla departman seçebilirsiniz"),
                      ]),
                    ]),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _vm.selectedDepartments.length > 0
                ? _c("div", { staticClass: "preview-section" }, [
                    _c("div", { staticClass: "preview-header" }, [
                      _c("div", { staticClass: "header-left" }, [
                        _c("i", { staticClass: "material-icons" }, [
                          _vm._v("apartment"),
                        ]),
                        _vm._v(" "),
                        _c("span", [_vm._v("Seçilen Departmanlar")]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "count-badge" }, [
                        _vm._v(_vm._s(_vm.selectedDepartments.length)),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "departments-grid" },
                      _vm._l(_vm.selectedDepartments, function (deptId) {
                        return _c(
                          "div",
                          { key: deptId, staticClass: "department-card" },
                          [
                            _c("div", { staticClass: "dept-icon" }, [
                              _c("i", { staticClass: "material-icons" }, [
                                _vm._v("corporate_fare"),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "dept-info" }, [
                              _c("div", { staticClass: "dept-name" }, [
                                _vm._v(
                                  _vm._s(_vm.getDepartmentNameById(deptId))
                                ),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "dept-check" }, [
                              _c("i", { staticClass: "material-icons" }, [
                                _vm._v("check_circle"),
                              ]),
                            ]),
                          ]
                        )
                      }),
                      0
                    ),
                  ])
                : _vm._e(),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "modal-footer" },
              [
                _c("SupsisButton", { on: { click: _vm.onCancel } }, [
                  _vm._v("İptal"),
                ]),
                _vm._v(" "),
                _c(
                  "SupsisButton",
                  { attrs: { primary: "" }, on: { click: _vm.onConfirm } },
                  [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("add_business"),
                    ]),
                    _vm._v("\n                Departman Ekle\n            "),
                  ]
                ),
              ],
              1
            ),
          ]),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }